import { createContext } from "react";

/**
 * Whether the mnemonic is rendering on the standalone Reference page.
 *
 * `false` is the correct default for every other mount: the Info and Mnemonics panels are what
 * people actually use in the app (and the only views reachable at all on native), so a missing
 * provider must mean "not the reference page" rather than throwing.
 */
export const MnemonicGateReferenceSurfaceContext = createContext(false);
